import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GwrGebaeudeEgidRequestMeta, GwrgebaeudeService } from '../../../../core/gwr-api';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GwrFormService } from '../../../gwr-form.service';
import { Subscription } from 'rxjs';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gwr-gebaeude-suche-egid',
  templateUrl: './gwr-gebaeude-suche-egid.component.html',
  styleUrls: ['./gwr-gebaeude-suche-egid.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class GwrGebaeudeSucheEgidComponent extends AbstractSearchComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild('egidTemplate', { static: false })
  egidField: ElementRef;

  egid: GwrGebaeudeEgidRequestMeta;

  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private route: ActivatedRoute,
    private router: Router,
    private formService: GwrFormService,
    private gwrgebaeudeService: GwrgebaeudeService
  ) {
    super(stateService);
  }

  ngOnInit() {
    this.subscription = this.gwrgebaeudeService.searchGebaeudeEgidTemplate().subscribe((template) => {
      this.egid = this.copyLastRequest(template, SearchMode.searchFachId);
    });
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.egid;
    this.formService.submit(this.form, SearchMode.searchFachId, this.egid, this.router, this.route, true);
  }

  onReset() {
    this.form.reset();
    this.subscription = this.gwrgebaeudeService.searchGebaeudeEgidTemplate().subscribe((template) => {
      this.egid = template;
      this.egidField.nativeElement.focus();
    });
  }

  ngAfterViewInit() {
    this.egidField.nativeElement.focus();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
